import type { Membership } from './useCurrentUser'

type Listener = () => void

function createStore() {
  let activeDistrictId: string | null = null
  const listeners = new Set<Listener>()
  return {
    snapshot: () => activeDistrictId,
    set(id: string | null) {
      if (id === activeDistrictId) return
      activeDistrictId = id
      for (const l of listeners) l()
    },
    subscribe(l: Listener) {
      listeners.add(l)
      return () => { listeners.delete(l) }
    },
  }
}

/** Global active-district store (mirrors the authStore pub/sub pattern). */
export const activeDistrictStore = createStore()

/**
 * Picks the active district on init: a still-valid stored choice wins; else the
 * first Admin/SuperAdmin membership; else the first membership; else null.
 * Matches the backend's own fallback so nav + data agree before any switch.
 */
export function resolveInitialActiveDistrict(
  memberships: Membership[],
  stored: string | null,
): string | null {
  if (!Array.isArray(memberships) || memberships.length === 0) return null
  if (stored && memberships.some((m) => m.districtId === stored)) return stored
  const admin = memberships.find((m) => m.role === 'Admin' || m.role === 'SuperAdmin')
  return (admin ?? memberships[0]).districtId
}
